export default "__VITE_ASSET__BHo3sbTr__"